export type IInitFieldsFormlinkWithChilds = (suffix?: string) => void;

export function _initFieldsFormlinkWithChilds(suffix?: string): void {
  let _suffix = typeof window.fieldSuffix !== 'undefined' ? window.fieldSuffix : '';
  if (suffix) {
    _suffix = suffix;
  }
  const fieldsFormlinkWithChildsObj = (window as any)[`fieldsFormlinkWithChilds${_suffix}`];
  if (($ as any).isBlank(fieldsFormlinkWithChildsObj)) {
    return;
  }
  // Key is the ID of the field, and the value is an array of ids of child linked fields
  $.each(fieldsFormlinkWithChildsObj, (key: string, childsArray) => {
    // Parent field
    const $parentField = $(`[name="field_${key}${_suffix}"]`);
    const formId = $parentField.data('form-id');
    const formLocale = $parentField.data('form-locale');

    for (const childIdent of childsArray) {
      // Disable all child linked fields, because the need a parent value to filter their values
      $(`[name="field_${childIdent}${_suffix}"]`).prop('disabled', true);
      if (window.debug) {
        ($ as any).log(`Disable Child Field: [name="field_${childIdent}${_suffix}"]`);
      }
    }
    if ($parentField.length) {
      $parentField
        .off('change')
        .on('change', (e) => {
          window.DexeroCoreApp.refreshFieldRelatedValues(
            formId,
            key,
            $(e.currentTarget).val() as string,
            _suffix,
            childsArray,
            window.appContext,
            formLocale
          );
        })
        .trigger('change');
      if (window.debug) {
        ($ as any).log(`Attach change event to Parent Field: [name="field_${key}${_suffix}"]`);
      }
    } else {
      const parentValue = window.DexeroCoreApp.getFieldRealValue(false, key, _suffix);
      const _formId = $(`[name="field_${childsArray[0]}${_suffix}"]`).data('form-id') || false;
      const _formLocale =
        $(`[name="field_${childsArray[0]}${_suffix}"]`).data('form-locale') || false;
      if (parentValue && parentValue.length && _formId) {
        window.DexeroCoreApp.refreshFieldRelatedValues(
          _formId,
          key,
          parentValue,
          _suffix,
          childsArray,
          window.appContext,
          _formLocale
        );
        if (window.debug) {
          ($ as any).log('Parent Field does not exists, trigger change on child directlyl');
        }
      }
    }
  });
}
